export const cachedDbConfig = {
  name: 'worksight-app',
  version: 40,
  stores: {
    'sales-office-contact': '++,userId',
    'sales-commission-code': '++,commCode',
    'sales-office': '++,salesOfficeName, salesOfficeId',
    'revenue-stream': '++,fieldValue',
    'sales-office-by-company-owned': '++,salesOfficeName',
    'sales-person': '++,salesOfficeId,commCode',
    'sales-office-by-sales-office-id': '++',
    'sales-office-by-dr-address': '++',
    'competitor-by-dr-address': '++',
    'classification': '++',
    'system-type': '++',
    'program': '++',
    'role-type-by-dr-address': '++',
    'user-sales-office': '++,drAddressId,groupName,salesOfficeName',
    'domain-list': '++',
    'master-business-stream': '++',
    'master-document-type': '++',
    'master-job-document-type': '++',
    'master-job-document-folder': '++',
    'notification': '++',
    'experimental-feature-toggle': '++',
    'user-sales-region': '++,salesRegionCode',
    'revenue-stream-contract-type': '++,revenueStreamId,contractType'
  }
};
